import DownloadIcon from '@mui/icons-material/Download';
import { Button } from '@mui/material';
import React, { useState } from 'react';

import { offlineClientsPage } from 'constants/offline-clients-page';
import { api } from 'services/api';

export const OfflineClientsPageDownloadButton = () => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      const {
        data: {
          data: { client },
        },
      } = await api.hasuraClientInstance.post('', {
        query: `
        {
            client (where: {isRemoved: {_eq: false}}, orderBy: [{
                firstName: ASC
            }, {
                lastName: ASC
            }]) {
                firstName
                lastName
                company {
                    name
                    bkh
                }

            }
        }
      `
          .replace(/\n/g, ' ')
          .replace(/ +/g, ' ')
          .trim(),
      });

      const htmlContent = offlineClientsPage(client);
      const blob = new Blob([htmlContent], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'klanten-overzicht.html';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error fetching clients for offline page:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outlined"
      startIcon={<DownloadIcon />}
      onClick={handleDownload}
      disabled={loading}
    >
      {loading ? 'Bezig met downloaden...' : 'Download overzicht'}
    </Button>
  );
};
